import React from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import YellowDivider from "../../dividers/YellowDivider";
import "../../../stylesheet/components/about/infosectionwithimage/InfoSectionWithImage.scss";

type InfoSectionWithImageProps = {
  className?: string;
  title: string;
  body: string;
  flipped?: boolean;
};

// the info section with image is a simplified version of the page heading with image
// check out the about page to see some invocations
const InfoSectionWithImage: React.FC<InfoSectionWithImageProps> = ({
  className,
  title,
  body,
  flipped = false,
}) => {
  //console.log(flipped);
  const { ready } = useTranslation();

  const getBody = () => {
    if (ready) {
      return body;
    }
    return (
      <div>
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
        <Skeleton width={500} />
      </div>
    );
  };

  return (
    <div className={`info-section ${className} ${flipped ? "flipped" : ""}`}>
      <div className="container">
        <div className="info-section__info-wrapper d-flex h-100 flex-column">
          <div className="col-12 col-md-6 px-0">
            <h2>{ready ? title : <Skeleton width={300} />}</h2>
            <YellowDivider heading={"h2"} />
            <div className="mx-xl-5 mt-3">
              <div className="mx-2 p3">{getBody()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoSectionWithImage;
